import { IPaymentPartner, PHONE_STATUS } from "../common";
import { useTranslation } from "react-i18next";
import { usePaymnetContext } from "../..";
import Loader from "../../Loader/Loader";
import PinConfirmation from "../pin.confirmation/pin.confirmation";
import PhoneConfirmation from "../phone.confirmation/phone.confirmation";
import CardError from "../card.error/card.error";

const PaymentConfirmation = ({ selectedPayment, onClose }: { selectedPayment?: IPaymentPartner, onClose: () => void }) => {
    const { state } = usePaymnetContext();
    return (
        <div className='popup'>
            <div className='popup_inner'>
                <img className="default" src={selectedPayment?.logoUrl || "https://pg-vnext-banners.s3.eu-central-1.amazonaws.com/vnext-images/pgvnext-payment-images/azampesabtn.svg"} />
                {state.phoneStatus === PHONE_STATUS.PHONE_REQUIRED && <PhoneConfirmation
                    selectedPayment={selectedPayment} onClose={onClose} />}

                {(state.phoneStatus === PHONE_STATUS.PHONE_NOT_REGISTER || state.phoneStatus === PHONE_STATUS.INVALID_PIN) && <CardError onClose={onClose} />}

                {(state.phoneStatus === PHONE_STATUS.PHONE_VERIFY || state.phoneStatus === PHONE_STATUS.CONFIRMATION_INPROGERSS) &&
                    <PinConfirmation selectedPayment={selectedPayment} onClose={onClose} />}
            </div>
        </div>
    );
}

export const PaymentFooter = ({ loading, submitTxt, onClose, onSubmit }: { loading?: boolean; submitTxt: string; onClose: () => void; onSubmit: () => void; }) => {
    const { t } = useTranslation();
    return (
        <footer>
            <button className="payment-btn cancle" onClick={onClose}>{t("cancel")}</button>
            <button className="payment-btn" disabled={loading} onClick={onSubmit}>{loading ? <Loader size="sm" /> : submitTxt}</button>
        </footer>
    )
}

export default PaymentConfirmation;